import { useState } from "react";
import { Wrapper, Datagrid, DeleteActionIcon, Permission } from "components";

import { Typography, IconButton, Button } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { endpoints } from "appConfigs";
import Form from "./Form";
import Filters from "./Filters";
import { useAppState } from "components/AppProvider/AppProvider";
import { useFetch } from "hooks";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme) => ({
  titleBar: {
    padding: "1rem 0 !important",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  centered: {
    margin: "0 auto",
  },
  label: {
    color: "#ffffff",
  },
  status: {
    textTransform: "capitalize",
  },
}));

const Drugs = () => {
  const { authUser } = useAppState();
  const classes = useStyles();
  const [edit, setEdit] = useState(null);
  const [filters, setFilters] = useState({});
  const { remove, loading } = useFetch(endpoints.drugs);
  return (
    <>
      <Wrapper padding={false}>
        <Grid container spacing={0} justify="center">
          <Grid item xs={10}>
            <Grid container spacing={1} direction="column" justify="center">
              <Grid item className={classes.titleBar}>
                <Typography variant="h5">
                  <FormattedMessage id="drugs" defaultMessage="Drugs" />
                </Typography>
                <Permission permission="add_drug">
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={() => setEdit(true)}
                  >
                    <FormattedMessage id="addDrug" defaultMessage="Add Durg" />
                  </Button>
                </Permission>
              </Grid>
              <Grid item>
                <Card>
                  <CardContent>
                    <Filters
                      filters={filters}
                      setFilters={setFilters}
                      authUser={authUser}
                    />
                  </CardContent>
                </Card>
              </Grid>
              <Grid item>
                <Datagrid
                  url={endpoints.drugs}
                  filters={filters}
                  columns={[
                    ...(authUser.user_type === "admin"
                      ? [
                          {
                            headerName: (
                              <FormattedMessage
                                id="hospital"
                                defaultMessage="Hospital"
                              />
                            ),
                            field: "hospital.name",
                            renderCell: ({ row }) => row.hospital?.name,
                          },
                        ]
                      : []),
                    {
                      headerName: (
                        <FormattedMessage
                          id="genericName"
                          defaultMessage="Generic Name"
                        />
                      ),
                      field: "generic_name",
                    },
                    {
                      headerName: (
                        <FormattedMessage
                          id="brandName"
                          defaultMessage="Brand Name"
                        />
                      ),
                      field: "brand_name",
                    },
                    {
                      headerName: (
                        <FormattedMessage
                          id="dosageForm"
                          defaultMessage="Dosage Form"
                        />
                      ),
                      field: "dosage_form",
                    },
                    {
                      headerName: (
                        <FormattedMessage id="price" defaultMessage="Price" />
                      ),
                      field: "price",
                    },
                    {
                      headerName: (
                        <FormattedMessage id="stock" defaultMessage="Stock" />
                      ),
                      field: "stock",
                    },
                    {
                      headerName: (
                        <>
                          <FormattedMessage
                            id="apiStrength"
                            defaultMessage="API strength"
                          />{" "}
                          (mg)
                        </>
                      ),
                      field: "api_strength",
                    },
                    {
                      headerName: (
                        <FormattedMessage id="action" defaultMessage="Action" />
                      ),
                      field: "action",
                      renderCell: ({ row }) => (
                        <>
                          <Permission permission="update_drugs">
                            <IconButton
                              aria-label={
                                <FormattedMessage
                                  id="editDrug"
                                  defaultMessage="Edit Drug"
                                />
                              }
                              onClick={() => setEdit(row)}
                            >
                              <EditIcon />
                            </IconButton>
                          </Permission>
                          <Permission permission="remove_drugs">
                            <DeleteActionIcon
                              disabled={loading}
                              title={
                                <FormattedMessage
                                  id="deleteDrug"
                                  defaultMessage="Delete Drug"
                                />
                              }
                              message={
                                <FormattedMessage
                                  id="deleteConfirmation_drug"
                                  defaultMessage="Are you sure want to remove this drug?"
                                />
                              }
                              deleteRecord={() => {
                                remove({ ids: row.id })
                                  .then(({ data }) => {
                                    if (data.success) {
                                      setFilters((prev) => ({ ...prev }));
                                    }
                                  })
                                  .catch((err) => {
                                    NotificationManager.error(err.message);
                                  });
                              }}
                            />
                          </Permission>
                        </>
                      ),
                    },
                  ]}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Form
          authUser={authUser}
          open={!!edit}
          edit={edit}
          setEdit={setEdit}
          onSuccess={(newSubPackage) => {
            setFilters((prev) => ({ ...prev }));
            setEdit(null);
          }}
        />
      </Wrapper>
    </>
  );
};

export default Drugs;
